import React from "react";

export default function FloatingWhatsApp() {
  const message = encodeURIComponent(
    "Hi, I’m interested in studying abroad. Can you guide me?"

  );
  return (
    <a
       href={`https://wa.me/917386252108?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[999] group"
    >
      <div className="
        w-16 h-16
        bg-[#25D366]
        rounded-full
        flex items-center justify-center
        shadow-2xl
        animate-bounce-slow
        hover:scale-110
        transition
        relative
      ">
        {/* Official WhatsApp SVG */}
        <svg viewBox="0 0 32 32" width="34" height="34" fill="white">
          <path d="M16 2.667c-7.36 0-13.333 5.973-13.333 13.333 0 2.347.64 4.64 1.853 6.64L2 30l7.547-2.4c1.947 1.067 4.133 1.6 6.453 1.6 7.36 0 13.333-5.973 13.333-13.333S23.36 2.667 16 2.667zm0 24c-2.027 0-4.027-.533-5.76-1.547l-.413-.24-4.48 1.427 1.453-4.373-.267-.427c-1.067-1.707-1.627-3.68-1.627-5.707 0-5.893 4.8-10.667 10.667-10.667S26.667 10.24 26.667 16 21.893 26.667 16 26.667zm5.813-7.893c-.32-.16-1.893-.933-2.187-1.04-.293-.107-.507-.16-.72.16-.213.32-.827 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.347-.493-2.56-1.573-.947-.84-1.587-1.88-1.773-2.2-.187-.32-.02-.493.14-.653.147-.147.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.733-.987-2.373-.26-.627-.52-.54-.72-.547-.187-.007-.4-.007-.613-.007-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.467 4.827.76.327 1.353.52 1.813.667.763.243 1.46.207 2.01.127.613-.093 1.893-.773 2.16-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373z"/>
        </svg>

        {/* Glow Pulse */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 blur-xl animate-pulse"></span>
      </div>
    </a>
  );
}
